import Vue from 'vue'
import VueRouter from 'vue-router'
import RegisterView from '../views/RegisterView.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  { path: '/',
    redirect: '/login'},
  {
    path: '/register',
    name: "S'inscrire",
    component: RegisterView,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/login',
    name: "Se connecter",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginView.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/dataSlopes',
    name: "Registre des pistes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/OpenSlopes.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dataDownloads',
    name: 'Historique',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Historic.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/map',
    name: 'Carte globale',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/MapLifts.vue'),
    meta: {
      requiresAuth: true,
      module: 'carte'
    }
  },
  {
    path: '/liftRecord',
    name: 'Registre RM',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LiftRecord.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/testsConfiguration',
    name: 'Configuration essais RM',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/TestsConfiguration.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/liftCentral',
    name: 'Central RMs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/LiftsGlobalDashboard.vue'),
    meta: {
      requiresAuth: true,
      requiresCentralRM: true
    }
  },
  {
    path: '/periodicChecks',
    name: 'PeriodicChecks',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PeriodicChecks.vue'),
    meta: {
      requiresAuth: true,
      requiresRM: true
    }
  },
  {
    path: '/manageAccounts',
    name: 'Gestion des comptes',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManageAccounts.vue'),
    meta: {
      requiresAdminOrRegul: true,
      requiresAuth: true
    }
  },
  {
    path: '/accountDetails/:id',
    name: 'Détails du compte',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AccountDetails.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reset-password/:token',
    name: 'Réinitialisation du mot de passe',
    component: () => import('../views/ResetPasswordView.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '*',
    name: '404 - Not Found',
    component: () => import(/* webpackChunkName: "about" */ '../views/404NotFound.vue'),
    meta: {
      requiresAuth: false
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // Vérifier toutes les conditions d'authentification
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.authStore.isUserLoggedIn) {
      return next({ path: '/login' })
    }
  }
  
  if (to.matched.some(record => record.meta.requiresAdminOrRegul)) {
    if (!store.state.authStore.isUserAdminOrRegul) {
      return next({ path: '/login' })
    }
  }
  
  if (to.matched.some(record => record.meta.requiresResponsableRMOrRegul)) {
    if (!store.state.authStore.isResponsableRMOrRegul) {
      return next({ path: '/login' })
    }
  }
  
  if (to.matched.some(record => record.meta.requiresRM)) {
    if (!store.state.authStore.isRM || !store.getters.isModuleEnabled('digirm')) {
      return next({ path: '/login' })
    }
  }

  // Central RMs : réservé aux responsables RM, mécaniciens, STRMTG, chefs d'équipe (et régulateurs)
  if (to.matched.some(record => record.meta.requiresCentralRM)) {
    if (!store.state.authStore.isCentralRMAllowed || !store.getters.isModuleEnabled('digirm')) {
      return next({ path: '/login' })
    }
  }

  if (to.matched.some(record => record.meta.requiresPistes)) {
    if (!store.state.authStore.isPistes || !store.getters.isModuleEnabled('digipistes')) {
      return next({ path: '/login' })
    }
  }

  // Garde générique par module (meta.module) : bloque la route si le module est
  // désactivé pour l'organisation. Extensible à tout futur module front.
  const moduleGatedRecord = to.matched.find(record => record.meta.module)
  if (moduleGatedRecord && !store.getters.isModuleEnabled(moduleGatedRecord.meta.module)) {
    return next({ path: '/login' })
  }

  // Si toutes les vérifications passent, continuer la navigation
  next()
})

export default router
